import classNames from 'classnames';
import React from 'react';
import styles from './FiltersBar.module.scss';
function FiltersBar({ noPadding, mainButton, searchInput, children }) {
    const classes = classNames(styles.wrap, {
        [styles.noPadding]: noPadding,
        [styles.withSearchInput]: searchInput,
    });
    return (React.createElement("div", { className: classes },
        mainButton && React.createElement("div", { className: styles.mainButton }, mainButton),
        searchInput && React.createElement("div", { className: styles.searchInput }, searchInput),
        children));
}
export default FiltersBar;
